var easingNames = [
	'linear',
	'easeInQuad',
	'easeInCubic',
	'easeInQuart',
	'easeInQuint',
	'easeInSine',
	'easeInExpo',
	'easeInCirc',
	'easeInBack',
	'easeOutQuad',
	'easeOutCubic',
	'easeOutQuart',
	'easeOutQuint',
	'easeOutSine',
	'easeOutExpo',
	'easeOutCirc',
	'easeOutBack',
	'easeInBounce',
	'easeInOutQuad',
	'easeInOutCubic',
	'easeInOutQuart',
	'easeInOutQuint',
	'easeInOutSine',
	'easeInOutExpo',
	'easeInOutCirc',
	'easeInOutBack',
	'easeInOutBounce',
	'easeOutBounce',
	'easeOutInQuad',
	'easeOutInCubic',
	'easeOutInQuart',
	'easeOutInQuint',
	'easeOutInSine',
	'easeOutInExpo',
	'easeOutInCirc',
	'easeOutInBack',
	'easeOutInBounce',
]

var canUseEasing = function (easingName) {
	if (typeof easingName !== 'string' || easingName === '') {
		return false
	}
	if (easingNames.indexOf(easingName) !== -1) {
		return true
	}
	if (typeof anime === 'undefined' || typeof anime.easing !== 'function') {
		return true
	}
	try {
		return typeof anime.easing(easingName) === 'function'
	} catch (e) {
		return false
	}
}

if (!canUseEasing(layData.navigation_transition_in_easing)) {
	layData.navigation_transition_in_easing = 'easeOutCubic'
}
if (!canUseEasing(layData.navigation_transition_out_easing)) {
	layData.navigation_transition_out_easing = 'easeInCubic'
}
